/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_Mock_1_StateInputs */

const en_cap_save_mock_1_state = /** @type {(inputs: Cap_Save_Mock_1_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft ready`)
};

const lv_cap_save_mock_1_state = /** @type {(inputs: Cap_Save_Mock_1_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melnraksts gatavs`)
};

/**
* | output |
* | --- |
* | "Draft ready" |
*
* @param {Cap_Save_Mock_1_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_mock_1_state = /** @type {((inputs?: Cap_Save_Mock_1_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_Mock_1_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_mock_1_state(inputs)
	return en_cap_save_mock_1_state(inputs)
});